module.exports = __webpack_public_path__ + "static/media/gorilla.498aac18.jpg";